export default "__VITE_ASSET__CEfPgo0d__"